import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { DockerHubConfigurationTab } from "./DockerHubConfigurationTab"

export const DockerHubConfigurationPage = () => {
  const vendor = INTEGRATION_VENDORS.dockerHub

  return (
    <ConfigurationPageTemplate
      vendor={vendor}
      config={<DockerHubConfigurationTab vendor={vendor} />}
      titleKey="integrations.configuration.docker_hub.configurationTitle"
    />
  )
}
